const init = () => {
  const form = document.querySelector('[data-ajaxify]')

  const addErrorNotification = (form, message) => {
    const div = document.createElement('div')
    div.className = 'alert alert-danger ajaxify-base-error'
    div.textContent = message || 'Please review the problems below:'
    form.prepend(div)
  }

  const handleSubmit = async e => {
    e.preventDefault()

    form.querySelector('.ajaxify-base-error')?.remove()
    form.querySelectorAll('.ajaxify-error-message')
    .forEach(element => element.remove())
    form.querySelectorAll('.is-invalid')
    .forEach(element => element.classList.remove('is-invalid'))

    const body = new FormData(form)
    const submitter = e.submitter
    if (submitter?.name)
      body.append(submitter.name, submitter.value)

    try {
      const response = await fetch(form.action, {
        method: form.method,
        headers: { Accept: 'application/json' },
        body,
      })
      if (response.ok) {
        $('#savedToast').toast('show')
        dispatchEvent(new Event('AjaxifyFormSubmitted'))
        form.querySelectorAll('.ajaxify-delete-button.d-none')
        .forEach(button => button.classList.remove('d-none'))
      } else {
        const errors = await response.json()
        console.error('Form errors', errors)
        addErrorNotification(form, errors.base?.[0])
        Object.keys(errors).forEach(key =>
          form.querySelectorAll(`#${form.dataset.ajaxify}_${key}`).forEach(input => {
            const element = input.closest('.input-group') || input
            const div = document.createElement('div')
            div.className = 'invalid-feedback ajaxify-error-message'
            div.textContent = errors[key][0]
            element.classList.add('is-invalid')
            element.after(div)
          })
        )
      }
    } catch (error) {
      console.error(error)
      addErrorNotification(form, 'A network or server error occured. See console for details.')
    }
  }

  const handleKeyDown = e => {
    if ((e.metaKey || e.ctrlKey) && e.key == 's')
      handleSubmit(e)
  }

  document.addEventListener('keydown', handleKeyDown)
  form.addEventListener('submit', handleSubmit)
}

document.addEventListener('DOMContentLoaded', init)
